import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from './locales/en/common.json';
import tlCommon from './locales/tl/common.json';

void i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'tl'],
  ns: ['common'],
  defaultNS: 'common',
  resources: {
    en: {
      common: enCommon,
    },
    tl: {
      common: tlCommon,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
